<script setup lang="ts">
import DashboardView from "./views/DashboardView.vue";
</script>

<template>
  <v-app>
    <v-main>
      <dashboard-view />
    </v-main>
  </v-app>
</template>
